module.exports = __webpack_public_path__ + "img/emoje-sad.a798b2dd.png";